<template>
    <CRow>
        <CCol col="12" xl="12">
            <CCard>
                <CCardBody>
                    <CCard class="p-4 m-0">
                        <CRow class="mb-1 ml-1 d-flex align-items-center justify-content-between">
                            <CCol class="d-flex align-items-center">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="showFilters" />
                                <span class="ml-2">Настройки/Экспорт</span>
                            </CCol>
                        </CRow>
                        <CRow v-if="showFilters" class="ml-1 mb-1 align-items-center">
                            <CCol>
                                <CRow class="mt-2">
                                    <CCol cols="12" md="4" class="mt-1 d-flex align-items-center">
                                        <span class="mr-1">Дата начала</span>
                                    </CCol>
                                    <CCol cols="12" md="8" class="mt-1 d-flex align-items-center">
                                        <DatePicker
                                            v-model="datepicker.dateFrom"
                                            :language="datepicker.lang"
                                            :format="datepicker.format"
                                            input-class="custom-datepicker"
                                            placeholder="Выберите дату..."
                                        />
                                    </CCol>
                                </CRow>
                                <CRow class="mt-2">
                                    <CCol cols="12" md="4" class="mt-1 d-flex align-items-center">
                                        <span class="mr-1">Дата окончания</span>
                                    </CCol>
                                    <CCol cols="12" md="8" class="mt-1 d-flex align-items-center">
                                        <DatePicker
                                            v-model="datepicker.dateTo"
                                            :language="datepicker.lang"
                                            :format="datepicker.format"
                                            input-class="custom-datepicker"
                                            placeholder="Выберите дату..."
                                        />
                                    </CCol>
                                </CRow>
                                <CRow class="mt-2">
                                    <CCol cols="12" md="4" class="mt-1 d-flex align-items-center">
                                        <span class="mr-1">Включить Отмененные/Инциденты</span>
                                    </CCol>
                                    <CCol cols="12" md="8" class="mt-1 d-flex align-items-center">
                                        <CSwitch
                                            color="dark"
                                            shape="pill"
                                            variant="opposite"
                                            :checked.sync="exportCanceled"
                                        />
                                    </CCol>
                                </CRow>
                                <CRow class="mt-2">
                                    <CCol
                                        cols="12"
                                        class="mt-2 flex">
                                        <CButton color="primary" :disabled="processStarted" @click="doExport">Экспорт</CButton>
                                        <!-- <CButton color="primary" class="ml-2" :disabled="processStarted" @click="doSendExport">Экспортировать и отправить всем получателям</CButton> -->
                                    </CCol>
                                </CRow>
                                <CRow v-if="processStarted" class="mt-2">
                                    <CCol cols="12" class="mt-2 flex">
                                        {{ exportMessage }}
                                        <CLink to="/export">{{ exportFile }}</CLink>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                    </CCard>
                </CCardBody>
            </CCard>
            <CCard>
                <CCardHeader class="d-flex" style="justify-content: space-between;">
                    <strong>Нераспределенные заказы</strong>
                    <CLink to="/vip-partners/orders">Все заказы</CLink>
                </CCardHeader>
                <CCardBody>
                    <OrdersTable :list.sync="items" class="mt-3" />
                    <CPagination
                        :active-page.sync="activePage"
                        class="mt-4"
                        :pages="total"
                        align="center"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import moment from 'moment';
    import OrdersTable from '@/components/orders/VipOrdersTable';
    import PartnersTabLinks from '@/components/partner/VipPartnersTabLinks';
    import DatePicker from 'vuejs-datepicker';
    import { ru } from 'vuejs-datepicker/dist/locale';
    import { ORDER_STATUS } from '../../utils/order';
    const { ITEMS_PER_PAGE } = require('../../utils/views');

    export default {

        name: 'PartnerOrders',

        components: {
            PartnersTabLinks,
            OrdersTable,
            DatePicker,
        },

        data() {
            return {
                entity: undefined,
                items: [],
                total: 1,
                showFilters: false,
                datepicker: {
                    lang: ru,
                    format: 'dd.MM.yyyy',
                    dateFrom: null,
                    dateTo: null,
                },
                processStarted: false,
                exportMessage: '',
                exportFile: '',
                exportFilter: ORDER_STATUS.DONE,
                exportFilterOptions: [
                    { value: ORDER_STATUS.DONE, label: 'По дате завершения' },
                    { value: ORDER_STATUS.PAID, label: 'По дате оплаты' },
                ],
                exportCanceled: false
            };
        },

        computed: {
            activePage: {
                get() {
                    return parseInt(this.$route.query.page) || 1;
                },
                async set(v) {
                    const query = { page: v };
                    this.$router.push({ query });
                },
            },
        },

        watch: {
            activePage: 'loadData',
        },

        async created() {
            await this.fetch();
            this.loadData();
        },

        methods: {
            async fetch() {
            },
            loadData() {
                const { id } = this.$route.params;
                const params = { page: this.activePage, pageSize: ITEMS_PER_PAGE, partner_id: id };
                this.axios
                    .get(`/vip-partners/orders/unallocated`, { params })
                    .then(resp => {
                        this.items = resp.data.results;
                        console.log('this.items', this.items)
                        this.total = Math.ceil(resp.data.total / ITEMS_PER_PAGE);
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки заказов. ' + err);
                    });
            },
            pageChange(val) {
                this.$router.push({ query: { page: val } });
            },
            doExport({ sendToEmail = false }) {
                if (!this.datepicker.dateFrom || !this.datepicker.dateTo) {
                    this.$root.$emit('showError', 'Укажите даты начала и окончания для экспорта');
                    return;
                }
                const filters = {
                    status: this.exportFilter,
                    canceled: this.exportCanceled,
                    unallocated: true
                }
                const dateFrom = moment(Date.parse(this.datepicker.dateFrom)).format('YYYY-MM-DD');
                const dateTo = moment(Date.parse(this.datepicker.dateTo)).format('YYYY-MM-DD');
                this.axios.get(
                    `/export/vip-orders?dateFrom=${dateFrom}&dateTo=${dateTo}&filter=${JSON.stringify(filters)}&difference=${this.showDifference}&sendToEmail=${sendToEmail}`
                ).then(res => {
                    this.exportMessage = res.data.message;
                    this.exportFile = res.data.filename;
                });
                this.processStarted = true;
            },
        },
    };
</script>
